import React, { useState } from "react";
import Message from "../Message";
import SuccessRes from "./SuccessRes";
import { createUserSchema } from "../../../joi/officeSchema";
import { createUserSetData } from "../../../../context/api/user/create-user/createUserSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const CreateUserModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  setRefreshData,
}) => {
  var schema = createUserSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);

  const createUser = (e) => {
    e.preventDefault();

    const credintial = {
      firstName: state.$data.firstName,
      secondName: state.$data.secondName,
      email: state.$data.email,
      role: state.$data.role,
    };

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return createUserSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>{dataTranslate.popups.create_user.title}</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_user.first_name}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              firstName: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("firstName", true)}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.firstName)}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_user.second_name}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              secondName: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("secondName", true)}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.secondName)}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_user.email}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              email: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("email", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.email)}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className=" mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_user.select.title}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Select
                          // defaultValue=""
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              role: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("role", true)}
                        >
                          <option selected>
                            {dataTranslate.popups.create_user.select.title}
                          </option>
                          <option value="ADMIN">
                            {dataTranslate.popups.create_user.select.admin}
                          </option>
                          <option value="EMPLOYEE">
                            {dataTranslate.popups.create_user.select.employee}
                          </option>
                        </Form.Select>

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.role)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    validate();
                    createUser(e);
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.create_user.add}
                </Button>

                <Button
                  onClick={() => {
                    reset();

                    onHide();
                  }}
                >
                  {dataTranslate.popups.create_user.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CreateUserModal;
